import React from "react"
import twitter from "../assets/images/icons/twitter.svg"
import facebook from "../assets/images/icons/facebook.svg"
import instagram from "../assets/images/icons/instagram.svg"
import youtube from "../assets/images/icons/youtube.svg"
import linkedin from "../assets/images/icons/linkedin.svg"
import telephone from "../assets/images/icons/telephone-fill.svg"
import envelope from "../assets/images/icons/envelope-fill.svg"

const socialMedia = [
  {
    name: "facebook",
    url: "https://www.facebook.com/urbancarechiropractic",
    image: facebook,
  },
  {
    name: "instagram",
    url: "https://www.instagram.com/urbancarechiropractic",
    image: instagram,
  },
  {
    name: "youtube",
    url: "https://www.youtube.com/channel/UCVWNfoTHKrUt8_3nDhYoMjg",
    image: youtube,
  },
  {
    name: "linkedin",
    url: "https://www.linkedin.com/company/urban-care-chiro",
    image: linkedin,
  },
]

export default React.memo(function Footer() {
  const d = new Date()

  return (
    <footer className="container-fluid" id="contact">
      <div
        className="row justify-content-between px-3 pt-5 pb-8 bg-light text-dark footer-basic"
        style={{ position: "relative", paddingBottom: "6rem" }}
      >
        <div className="social">
          {socialMedia.map((network, i) => (
            <a
              key={i}
              href={network.url}
              className="icon"
              target="_blank"
              rel="noreferrer"
            >
              <img
                alt={network.name}
                src={network.image}
                width="60%"
                className="position-relative"
                style={{ top: "-10%" }}
              />
            </a>
          ))}
        </div>
        <ul
          className="contact d-block position-relative start-50 translate-middle-x my-2"
          style={{ maxWidth: "20em" }}
        >
          <li className="">
            <a href="tel:312-841-5500" className="text-dark">
              <span
                itemProp="telephone"
                className="border rounded d-block my-2 px-3 py-2"
              >
                <img
                  src={telephone}
                  alt="telephone"
                  width="18px"
                  style={{ marginRight: "0.3rem" }}
                />
                312-841-5500
              </span>
            </a>
          </li>
          <li className="">
            <a href="mailto:urbancarechiro@gmail.com" className="text-dark">
              <span
                itemProp="email"
                className="border rounded d-block my-2 px-3 py-2"
              >
                <img
                  src={envelope}
                  alt="email"
                  height="18px"
                  style={{ marginRight: "0.3rem" }}
                />
                urbancarechiro@gmail.com
              </span>
            </a>
          </li>
        </ul>
        <div className="powered-by">
          <svg
            width={730.753}
            height={102.809}
            viewBox="0 0 193.345 27.202"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              aria-label="Powered by"
              style={{
                fontSize: "16.9333px",
                lineHeight: 1.2,
                strokeWidth: 0.264583,
                fill: "#000",
                opacity: "0.46",
              }}
            >
              <path
                d="M25.948 116.352c0-1.88-1.287-3.471-3.607-3.471h-3.64c-.61 0-1.101.49-1.101 1.1v9.466c0 .457.372.83.83.83a.835.835 0 0 0 .846-.83v-3.624h3.065c2.286 0 3.607-1.591 3.607-3.47zm-1.727 0c0 1.168-.864 1.981-2.1 1.981h-2.845v-3.962h2.845c1.236 0 2.1.796 2.1 1.981zM35.193 120.077c0-2.353-1.574-4.284-4.131-4.284-2.54 0-4.115 1.93-4.115 4.284s1.575 4.301 4.115 4.301c2.557 0 4.131-1.947 4.131-4.3zm-1.574 0c0 1.575-.915 2.964-2.557 2.964-1.626 0-2.557-1.389-2.557-2.964 0-1.557.931-2.946 2.557-2.946 1.642 0 2.557 1.389 2.557 2.946zM48.118 116.623a.727.727 0 0 0-.745-.728c-.322 0-.627.203-.711.508l-1.744 5.842-1.914-5.774a.834.834 0 0 0-.779-.576.85.85 0 0 0-.83.576l-1.896 5.774-1.744-5.842c-.102-.305-.424-.508-.745-.508-.424 0-.728.372-.728.728a.85.85 0 0 0 .033.203l2.134 6.757a.997.997 0 0 0 .931.694h.034c.44 0 .83-.288.948-.694l1.846-5.707 1.829 5.707c.135.406.508.694.948.694h.017c.44 0 .83-.288.948-.694l2.134-6.757a.85.85 0 0 0 .034-.203zM57.248 119.806c0-.321-.085-.677-.152-.948-.474-1.829-1.829-3.065-3.81-3.065-2.37 0-4.081 1.914-4.081 4.284 0 2.574 1.778 4.301 4.216 4.301 1.033 0 3.133-.457 3.133-1.371 0-.373-.339-.61-.61-.61a.77.77 0 0 0-.338.085 3.483 3.483 0 0 1-2.032.677c-1.66 0-2.676-1.185-2.794-2.59h5.69a.785.785 0 0 0 .778-.762zm-1.456-.304H50.78c.067-1.135.863-2.49 2.489-2.49 1.744 0 2.489 1.389 2.523 2.49zM63.489 116.555a.659.659 0 0 0-.677-.677c-.915 0-1.66.762-2.117 1.388v-.643a.745.745 0 0 0-.728-.728c-.44 0-.78.339-.78.728v6.909c0 .406.323.728.729.745h.017a.755.755 0 0 0 .762-.745v-5.046c.49-.728 1.253-1.067 2.032-1.135.423-.034.762-.355.762-.796zM72.462 119.806c0-.321-.085-.677-.153-.948-.474-1.829-1.829-3.065-3.81-3.065-2.37 0-4.08 1.914-4.08 4.284 0 2.574 1.777 4.301 4.216 4.301 1.033 0 3.132-.457 3.132-1.371 0-.373-.338-.61-.61-.61a.77.77 0 0 0-.338.085 3.483 3.483 0 0 1-2.032.677c-1.66 0-2.675-1.185-2.794-2.59h5.69a.785.785 0 0 0 .779-.762zm-1.457-.304h-5.012c.068-1.135.864-2.49 2.49-2.49 1.743 0 2.489 1.389 2.522 2.49zM81.75 123.532v-10.025a.745.745 0 0 0-.728-.728c-.44 0-.779.339-.779.728v3.675c-.66-.88-1.625-1.389-2.692-1.389-2.134 0-3.64 1.677-3.64 4.301 0 2.676 1.523 4.284 3.64 4.284 1.1 0 2.066-.558 2.692-1.371v.525c0 .406.339.745.745.745a.755.755 0 0 0 .762-.745zm-1.507-1.694c-.423.678-1.354 1.203-2.303 1.203-1.524 0-2.472-1.236-2.472-2.947 0-1.71.948-2.963 2.472-2.963.949 0 1.88.559 2.303 1.22zM96.397 120.094c0-2.624-1.524-4.3-3.641-4.3-1.084 0-2.032.507-2.692 1.388v-3.675a.745.745 0 0 0-.729-.728c-.44 0-.778.339-.778.728v10.025c0 .406.338.745.745.745a.755.755 0 0 0 .762-.745v-.525c.61.813 1.591 1.371 2.692 1.371 2.117 0 3.64-1.608 3.64-4.284zm-1.575 0c0 1.71-.932 2.947-2.49 2.947-.914 0-1.862-.525-2.268-1.186v-3.505c.406-.66 1.354-1.219 2.269-1.219 1.557 0 2.489 1.253 2.489 2.963zM105.204 116.64a.755.755 0 0 0-.762-.745.775.775 0 0 0-.711.474l-2.405 6.062-2.421-6.062a.743.743 0 0 0-.694-.474.755.755 0 0 0-.762.745c0 .085.017.17.05.254l3.031 7.383-.474 1.084c-.27.592-.643.779-1.1.779-.119.016-.254 0-.39 0a.669.669 0 0 0-.677.677c0 .559.559.677 1.084.677 1.1 0 1.998-.508 2.523-1.744l3.657-8.856a.618.618 0 0 0 .051-.254z"
                style={{
                  fontWeight: 500,
                  fontFamily: "'Proxima Nova Soft'",
                  InkscapeFontSpecification: "'Proxima Nova Soft Medium'",
                }}
                transform="translate(-17.6 -106.58)"
              />
            </g>
            <path
              className="R"
              d="M125.275 106.65c-.938.1-1.71.247-2.715.56-2.73.856-5.182 2.945-6.268 5.314-.691 1.53-.84 2.222-.856 3.982-.016 1.975.313 3.225 1.234 4.772.708 1.184 2.929 3.455 3.373 3.455.115 0 .214.033.214.098 0 .05-.543.807-1.185 1.679-.658.872-1.316 1.744-1.447 1.941-.313.46-2.189 2.912-2.304 3.028-.132.131-1.415 1.859-1.547 2.09-.082.147 1.136.197 5.216.213h5.315l1.2-1.843c.659-1.02 1.778-2.764 2.502-3.883.723-1.118 1.382-1.974 1.464-1.925.099.066.164 1.596.164 3.883v3.768h9.708l-.033-13.59-.05-13.59-6.416-.017c-3.521-.017-6.927.016-7.569.066zm4.327 10.3-.049 3.094h-1.07c-.592.016-1.25-.083-1.48-.198-.23-.115-.51-.214-.625-.214-.264 0-1.07-.79-1.35-1.316-.131-.23-.213-.872-.213-1.448.016-1.99 1.217-2.994 3.553-2.994h1.267z"
              style={{
                fill: "#e06161",
                stroke: "none",
                strokeWidth: 0.0164533,
              }}
              transform="translate(-17.6 -106.58)"
            />
            <text
              xmlSpace="preserve"
              style={{
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "10.5833px",
                lineHeight: 1.25,
                fontFamily: "sans-serif",
                fill: "#000",
                fillOpacity: 1,
                stroke: "none",
                strokeWidth: 0.264583,
              }}
              x={141.866}
              y={117.031}
              transform="translate(-17.6 -106.58)"
            >
              <tspan
                style={{
                  strokeWidth: 0.264583,
                }}
                x={141.866}
                y={117.031}
              />
            </text>
            <g
              aria-label="BeRebel"
              style={{
                fontSize: "16.9333px",
                lineHeight: 1.25,
                strokeWidth: 0.264583,
                fill: "#000",
                opacity: "0.46",
              }}
            >
              <path
                d="M159.294 121.762c0-1.371-1-2.59-2.201-2.777 1.05-.22 1.98-1.168 1.98-2.59 0-1.643-1.184-2.88-3.2-2.88h-4.165c-.61 0-1.1.492-1.1 1.101v9.094c0 .61.49 1.1 1.1 1.1h4.3c2.1 0 3.286-1.27 3.286-3.048zm-1.947-5.114c0 .949-.644 1.66-1.778 1.66h-3.285v-3.32h3.285c1.134 0 1.778.729 1.778 1.66zm.22 4.911c0 1.1-.711 1.778-1.93 1.778h-3.353v-3.556h3.352c1.27 0 1.93.83 1.93 1.778zM168.923 120.441c0-.321-.084-.677-.152-.948-.474-1.829-1.829-3.065-3.81-3.065-2.37 0-4.08 1.914-4.08 4.284 0 2.574 1.777 4.301 4.216 4.301 1.032 0 3.132-.457 3.132-1.371 0-.373-.338-.61-.61-.61a.77.77 0 0 0-.338.085 3.484 3.484 0 0 1-2.032.677c-1.66 0-2.676-1.185-2.794-2.59h5.69a.785.785 0 0 0 .778-.763zm-1.456-.304h-5.012c.068-1.135.864-2.49 2.49-2.49 1.743 0 2.488 1.389 2.522 2.49zM179.262 116.987c0-2.1-1.473-3.471-3.607-3.471h-3.64c-.61 0-1.101.49-1.101 1.1v9.466c0 .457.372.83.83.83a.835.835 0 0 0 .846-.83v-3.624h2.117l2.54 4.064a.78.78 0 0 0 .677.39c.491 0 .83-.407.83-.813a.848.848 0 0 0-.118-.423l-2.185-3.387c1.456-.186 2.811-1.287 2.811-3.302zm-3.827-1.981c1.236 0 2.1.796 2.1 1.981s-.864 1.998-2.1 1.998h-2.845v-3.98zM188.37 120.441c0-.321-.084-.677-.152-.948-.474-1.829-1.829-3.065-3.81-3.065-2.37 0-4.081 1.914-4.081 4.284 0 2.574 1.778 4.301 4.216 4.301 1.033 0 3.133-.457 3.133-1.371 0-.373-.339-.61-.61-.61a.77.77 0 0 0-.338.085 3.483 3.483 0 0 1-2.032.677c-1.66 0-2.676-1.185-2.794-2.59h5.69a.785.785 0 0 0 .778-.763zm-1.456-.304h-5.012c.067-1.135.863-2.49 2.489-2.49 1.744 0 2.49 1.389 2.523 2.49zM198.15 120.73c0-2.625-1.524-4.302-3.64-4.302-1.084 0-2.033.508-2.693 1.389v-3.675a.745.745 0 0 0-.728-.728c-.44 0-.779.339-.779.728v10.025c0 .406.339.745.745.745a.755.755 0 0 0 .762-.745v-.525c.61.813 1.592 1.371 2.692 1.371 2.117 0 3.641-1.608 3.641-4.284zm-1.575 0c0 1.71-.931 2.946-2.489 2.946-.914 0-1.863-.525-2.269-1.186v-3.505c.406-.66 1.355-1.219 2.27-1.219 1.557 0 2.488 1.253 2.488 2.963zM207.652 120.441c0-.321-.085-.677-.153-.948-.474-1.829-1.828-3.065-3.81-3.065-2.37 0-4.08 1.914-4.08 4.284 0 2.574 1.777 4.301 4.216 4.301 1.033 0 3.133-.457 3.133-1.371 0-.373-.34-.61-.61-.61a.77.77 0 0 0-.339.085 3.483 3.483 0 0 1-2.032.677c-1.66 0-2.675-1.185-2.794-2.59h5.69a.785.785 0 0 0 .779-.763zm-1.456-.304h-5.013c.068-1.135.864-2.49 2.49-2.49 1.744 0 2.489 1.389 2.523 2.49zM211.099 124.167v-10.025a.745.745 0 0 0-.729-.728c-.44 0-.779.339-.779.728v10.025c0 .406.34.745.745.745a.755.755 0 0 0 .762-.745z"
                style={{
                  fontWeight: 500,
                  fontFamily: "'Proxima Nova Soft'",
                  InkscapeFontSpecification: "'Proxima Nova Soft Medium'",
                }}
                transform="translate(-17.6 -106.58)"
              />
            </g>
          </svg>
        </div>
      </div>
    </footer>
  )
})
